import React from 'react';
import { translate } from '../Services/translation';
import { useSelector } from 'react-redux';

const MiniCart = ({ variant = 'legacy' }) => {
  const { quantity, orderTotal, checkoutUrl } = useSelector(
    (state) => state.cart
  );

  if (variant === 'redesign-pill') {
    // Tailwind utilities only resolve inside a .use-tailwind ancestor (the header);
    // harmless noise elsewhere. Icon-only circle < sm, pill with order total from sm up.
    const showBadge = quantity > 0;
    return (
      <a
        className="cart__redesign-pill inline-flex items-center justify-center gap-2 w-10 h-10 sm:w-auto sm:justify-start sm:pl-4 sm:pr-4 md:h-12 md:pl-5 md:pr-4 rounded-full bg-brand-dark-green text-off-white font-manrope font-medium text-base whitespace-nowrap hover:opacity-90 transition-opacity"
        rel="nofollow"
        href={checkoutUrl}
        aria-label={translate('minicart.checkout')}
      >
        <span className="relative inline-flex shrink-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            className="w-6 h-6"
          >
            <path d="M16 10a4 4 0 0 1-8 0" />
            <path d="M3.103 6.034h17.794" />
            <path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z" />
          </svg>
          {showBadge && (
            <span className="absolute -top-2 -left-2.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-brand-turquoise text-brand-dark-green text-xs font-semibold leading-none">
              {quantity}
            </span>
          )}
        </span>
        <span className="hidden sm:inline">{orderTotal}</span>
      </a>
    );
  }

  return (
    <a className="cart__mini--link-block" rel="nofollow" href={checkoutUrl}>
      <span className="cart__title hide">
        {translate('minicart.checkout')}
      </span>
      <div className="cart__mini--icon">
        <span className="cart__mini--quantity">{quantity}</span>
        <div className="cart__mini--icon-container">
          <span className="smdicon-shopping-cart"></span>
        </div>
      </div>
      <div className="cart__mini--container">
        <div className="cart__mini--cart">
          <span className="amount">{translate('minicart.total')}</span>
          <span className="amount-value">{orderTotal}</span>
        </div>
      </div>
      <div className="cart__mini--arrow">
        <span className="smdicon-caret-right"></span>
      </div>
    </a>
  );
};

export default MiniCart;
